const PermissionConstants = {
    DUMMY: "dummy",
    COMPANY_VIEW: "company_view",
    COMPANY_CREATE: "company_create",
    COMPANY_UPDATE: "company_update",
    COMPANY_DELETE: "company_delete",
    USER_VIEW: "user_view",
    USER_CREATE: "user_create",
    USER_UPDATE: "user_update",
    USER_DELETE: "user_delete",
    GROUP_VIEW: "group_view",
    GROUP_CREATE: "group_create",
    GROUP_UPDATE: "group_update",
    GROUP_DELETE: "group_delete",
    DEPARTMENT_VIEW: "department_view",
    DEPARTMENT_CREATE: "department_create",
    DEPARTMENT_UPDATE: "department_update",
    DEPARTMENT_DELETE: "department_delete",
    DEPARTMENT_UPLOAD: "department_upload",
    AREA_VIEW: "area_view",
    AREA_CREATE: "area_create",
    AREA_UPDATE: "area_update",
    AREA_DELETE: "area_delete",
    AREA_CSV_UPLOAD: "area_csv_upload",
    AREA_CSV_DOWNLOAD: "area_csv_download",
    SCHOOL_VIEW: "school_view",
    SCHOOL_CREATE: "school_create",
    SCHOOL_UPDATE: "school_update",
    SCHOOL_DELETE: "school_delete",
    SCHOOL_UPLOAD: "school_upload",
    CALENDAR_MANAGEMENT_VIEW: "calendar_management_view",
    CALENDAR_MANAGEMENT_CREATE: "calendar_management_create",
    CALENDAR_MANAGEMENT_UPDATE: "calendar_management_update",
    ZONE_VIEW: "zone_view",
    ZONE_CREATE: "zone_create",
    ZONE_UPDATE: "zone_update",
    TRANSPORT_TYPE_VIEW: "transport_type_view",
    TRANSPORT_TYPE_CREATE: "transport_type_create",
    TRANSPORT_TYPE_UPDATE: "transport_type_update",
    TRANSPORT_TYPE_DELETE: "transport_type_delete",
    FEES_TYPE_VIEW: "fees_type_view",
    FEES_TYPE_CREATE: "fees_type_create",
    FEES_TYPE_UPDATE: "fees_type_update",
    FEES_TYPE_DELETE: "fees_type_delete",
    FEES_SETUP_VIEW: "fees_setup_view",
    FEES_SETUP_CREATE: "fees_setup_create",
    FEES_SETUP_UPDATE: "fees_setup_update",
    FEES_SETUP_DELETE: "fees_setup_delete",
    TRANSACTION_CODE_SETUP_VIEW: "transaction_code_setup_view",
    TRANSACTION_CODE_SETUP_CREATE: "transaction_code_setup_create",
    TRANSACTION_CODE_SETUP_UPDATE: "transaction_code_setup_update",
    TRANSACTION_CODE_SETUP_DELETE: "transaction_code_setup_delete",
    CLASS_PROMOTION_VIEW: "class_promotion_view",
    CLASS_PROMOTION_CREATE: "class_promotion_create",
    CLASS_PROMOTION_UPDATE: "class_promotion_update",
    BUS_DETAIL_VIEW: "bus_detail_view",
    BUS_DETAIL_CREATE: "bus_detail_create",
    BUS_DETAIL_UPDATE: "bus_detail_update",
    FINANCE_TRANSACTION_CODE_SETUP_VIEW: "finance_transaction_code_setup_view",
    FINANCE_TRANSACTION_CODE_SETUP_CREATE: "finance_transaction_code_setup_create",
    FINANCE_TRANSACTION_CODE_SETUP_UPDATE: "finance_transaction_code_setup_update",
    FINANCE_TRANSACTION_CODE_SETUP_DELETE: "finance_transaction_code_setup_delete",
    MODE_OF_PAY_VIEW: "mode_of_pay_view",
    MODE_OF_PAY_CREATE: "mode_of_pay_create",
    MODE_OF_PAY_UPDATE: "mode_of_pay_update",
    MODE_OF_PAY_DELETE: "mode_of_pay_delete",
    CURRENCY_VIEW: "currency_view",
    CURRENCY_CREATE: "currency_create",
    CURRENCY_UPDATE: "currency_update",
    CURRENCY_DELETE: "currency_delete",
    CUSTOMER_VIEW: "customer_view",
    CUSTOMER_CREATE: "customer_create",
    CUSTOMER_UPDATE: "customer_update",
    CUSTOMER_DELETE: "customer_delete",
    SUPPLIER_VIEW: "supplier_view",
    SUPPLIER_CREATE: "supplier_create",
    SUPPLIER_UPDATE: "supplier_update",
    SUPPLIER_DELETE: "supplier_delete",
    ACCOUNT_LEDGER_VIEW: "account_ledger_view",
    ACCOUNT_LEDGER_CREATE: "account_ledger_create",
    ACCOUNT_LEDGER_UPDATE: "account_ledger_update",
    ACCOUNT_LEDGER_DELETE: "account_ledger_delete",
    BANK_DETAIL_VIEW: "bank_detail_view",
    BANK_DETAIL_CREATE: "bank_detail_create",
    BANK_DETAIL_UPDATE: "bank_detail_update",
    BANK_DETAIL_DELETE: "bank_detail_delete",
    MAIN_GROUP_LEDGER_VIEW: "main_group_ledger_view",
    MAIN_GROUP_LEDGER_CREATE: "main_group_ledger_create",
    MAIN_GROUP_LEDGER_UPDATE: "main_group_ledger_update",
    MAIN_GROUP_LEDGER_DELETE: "main_group_ledger_delete",
    CHEQUE_TRANSACTION_SETUP_VIEW: "cheque_transaction_setup_view",
    CHEQUE_TRANSACTION_SETUP_CREATE: "cheque_transaction_setup_create",
    CHEQUE_TRANSACTION_SETUP_UPDATE: "cheque_transaction_setup_update",
    CHEQUE_TRANSACTION_SETUP_DELETE: "cheque_transaction_setup_delete",
    CASH_LEDGER_VIEW: "cash_ledger_view",
    CASH_LEDGER_CREATE: "cash_ledger_create",
    CASH_LEDGER_UPDATE: "cash_ledger_update",
    CASH_LEDGER_DELETE: "cash_ledger_delete",
    GROUP_HEADER_VIEW: "group_header_view",
    GROUP_HEADER_CREATE: "group_header_create",
    GROUP_HEADER_UPDATE: "group_header_update",
    MAIN_GROUP_VIEW: "main_group_view",
    MAIN_GROUP_CREATE: "main_group_create",
    MAIN_GROUP_UPDATE: "main_group_update",
    SUB_ACCOUNT_VIEW: "sub_account_view",
    SUB_ACCOUNT_CREATE: "sub_account_create",
    SUB_ACCOUNT_UPDATE: "sub_account_update",
    ACCOUNT_VIEW: "account_view",
    ACCOUNT_CREATE: "account_create",
    ACCOUNT_UPDATE: "account_update",
    STUDENT_VIEW: "student_view",
    STUDENT_CREATE: "student_create",
    STUDENT_UPDATE: "student_update",
    STUDENT_DOWNLOAD: "student_download",
    STUDENT_CSV_DOWNLOAD: "student_csv_download",
    STUDENT_CSV_UPLOAD: "student_csv_upload",
    INVOICE_VIEW: "invoice_view",
    INVOICE_CREATE: "invoice_create",
    INVOICE_UPDATE: "invoice_update",
    INVOICE_DOWNLOAD: "invoice_download",
    INVOICE_CSV_DOWNLOAD: "invoice_csv_download",
    RECEIPT_VIEW: "receipt_view",
    RECEIPT_CREATE: "receipt_create",
    RECEIPT_UPDATE: "receipt_update",
    RECEIPT_DOWNLOAD: "receipt_download",
    RECEIPT_CSV_DOWNLOAD: "receipt_csv_download",
    RECEIPT_DELETE: "receipt_delete",
    SOA_VIEW: "soa_view",
    SOA_DOWNLOAD: "soa_download",
    GRADE_VIEW: "grade_view",
    GRADE_CREATE: "grade_create",
    GRADE_UPDATE: "grade_update",
    TERM_VIEW: "term_view",
    TERM_CREATE: "term_create",
    TERM_UPDATE: "term_update",
    FORM_VIEW: "form_view",
    FORM_CREATE: "form_create",
    FORM_DOWNLOAD: "form_download",
    PAYMENT_VOUCHER_VIEW: "payment_voucher_view",
    PAYMENT_VOUCHER_CREATE: "payment_voucher_create",
    PAYMENT_VOUCHER_UPDATE: "payment_voucher_update",
    PAYMENT_VOUCHER_DELETE: "payment_voucher_delete",
    PAYMENT_VOUCHER_DOWNLOAD: "payment_voucher_download",
    JOURNAL_VOUCHER_VIEW: "journal_voucher_view",
    JOURNAL_VOUCHER_CREATE: "journal_voucher_create",
    JOURNAL_VOUCHER_UPDATE: "journal_voucher_update",
    JOURNAL_VOUCHER_DELETE: "journal_voucher_delete",
    JOURNAL_VOUCHER_DOWNLOAD: "journal_voucher_download",
    PREPAYMENT_VOUCHER_VIEW: "prepayment_voucher_view",
    PREPAYMENT_VOUCHER_CREATE: "prepayment_voucher_create",
    PREPAYMENT_VOUCHER_UPDATE: "prepayment_voucher_update",
    PREPAYMENT_VOUCHER_DELETE: "prepayment_voucher_delete",
    PREPAYMENT_VOUCHER_DOWNLOAD: "prepayment_voucher_download",
    DEBIT_NOTE_VIEW: "debit_note_view",
    DEBIT_NOTE_CREATE: "debit_note_create",
    DEBIT_NOTE_UPDATE: "debit_note_update",
    DEBIT_NOTE_DOWNLOAD: "debit_note_download",
    DEBIT_NOTE_DELETE: "debit_note_delete",
    CREDIT_NOTE_VIEW: "credit_note_view",
    CREDIT_NOTE_CREATE: "credit_note_create",
    CREDIT_NOTE_UPDATE: "credit_note_update",
    CREDIT_NOTE_DOWNLOAD: "credit_note_download",
    CREDIT_NOTE_DELETE: "credit_note_delete",
    PDC_BANK_PAYMENT_VIEW: "pdc_bank_payment_view",
    PDC_BANK_PAYMENT_CREATE: "pdc_bank_payment_create",
    PDC_BANK_PAYMENT_UPDATE: "pdc_bank_payment_update",
    PDC_BANK_PAYMENT_DELETE: "pdc_bank_payment_delete",
    PDC_BANK_PAYMENT_DOWNLOAD: "pdc_bank_payment_download",
    DISCOUNT_VIEW: "discount_view",
    DISCOUNT_CREATE: "discount_create",
    DISCOUNT_UPDATE: "discount_update",
    DAILY_FEE_REPORT: "daily_fee_report",
    OUTSTANDING_FEE_REPORT: "outstanding_fee_report"
}
export default PermissionConstants;
